<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container bluebtn overflow-hidden">
      <div class="dashboardAdmin-header">
        <div class="dashboardAdmin-header-main-head">Job Approval</div>
      </div>
      <div class="viewopsheadjdcontainer mt-2">
        <div class="newInt-control-tabs h-100">
          <b-tabs v-model="tabIndex">
            <b-tab
              title="Pending Jobs"
              @click="
                openPreview = false;
                getJobDesc(
                  (type = '1'),
                  (status = '2'),
                  (currentPage = 1),
                  (goToPage = null),
                  (LoaderStatus = true)
                );
              "
            >
              <template
                v-if="allJobs.length == 0 && !LoaderStatus && searchQuery == ''"
              >
                <div
                  class="
                    bu-head-no-data-class
                    d-flex
                    align-items-center
                    justify-content-center
                    flex-column
                  "
                >
                  <div>
                    <img src="../../assets/newJD/newJD-emptyData.svg" alt="" />
                  </div>
                  <div class="ml-4 teams-empty-container-font">
                    There are no pending jobs
                  </div>
                </div>
              </template>
              <div v-else>
                <!-- new table design starts from here -->
                <div class="newJD-main-table">
                  <div class="newJD-table-head">
                    <div class="text-left pl-3" style="width: 30%">
                      <span>Customer Name</span>
                      <template v-if="statusValue == 'customerName'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 30%" class="text-left">
                      <span>Job Name</span>
                      <template v-if="statusValue == 'title'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 25%" class="text-left">
                      <span>Sent on</span>
                    </div>
                    <div style="width: 15%" class="text-center">
                      <span>Action</span>
                    </div>
                  </div>
                  <div class="newJD-table-body" ref="tableContainer1">
                    <template
                      v-if="
                        allJobs.length == 0 &&
                        !LoaderStatus &&
                        searchQuery != ''
                      "
                    >
                      <div
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                          flex-column
                        "
                      >
                        <div>
                          <img
                            src="../../assets/newJD/newJD-emptyData.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-4 teams-empty-container-font">
                          No matching results for "{{ searchQuery }}"
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="newJD-table-row"
                        v-for="(job, index) in allJobs"
                        :key="job.jobID + index"
                      >
                        <div class="text-left pl-3" style="width: 30%">
                          <span class="newJD-gridgreencolorDynamic"></span>
                          <span
                            style="min-width: auto; max-width: 95%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.customerName"
                            >{{ job.customerName }}</span
                          >
                        </div>

                        <div style="width: 30%" class="text-left text-truncate">
                          <span
                            style="min-width: auto; max-width: 90%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.title"
                            >{{ job.title }}</span
                          >
                        </div>
                        <div style="width: 25%" class="text-left">
                          {{ job.sentOn | formatdate }}
                        </div>

                        <div style="width: 15%" class="text-center">
                          <span
                            ><img
                              v-b-tooltip.hover.top="'Click to view'"
                              src="../../assets/newJD/newJD-eye-icon.svg"
                              alt="/"
                              class="pointer"
                              @click="
                                (isPending = true), openPreviewSlide(job.jobID)
                              "
                          /></span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="
                      acs-paginaTion-new
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div class="d-flex">
                      <span class="acs-gotopage-text p-1">Go to page</span>
                      <b-form-input
                        type="text"
                        class="acs-pagination-num mr-1"
                        v-model="goToPage"
                        @keyup.enter="
                          goToPage == null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages()
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>
                      <div class="acs-pagination-addbtn">
                        <span
                          :class="
                            goToPage == null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? 'disableDeleteIcon pl-3 mt-1'
                              : 'pointer pl-3 mt-1'
                          "
                        >
                          <img
                            @click="
                              goToPage == null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages()
                            "
                            src="../../assets/panelist/page_arrow.svg"
                            alt
                          />
                        </span>
                      </div>
                    </div>

                    <div class="pagination">
                      <b-pagination
                        v-model.number="currentPage"
                        @input="goToPage = null"
                        :total-rows="total"
                        :per-page="question_count"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/leftvector.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/rightarrow.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex align-items-center">
                      <PageInput
                        :pagecount="question_count"
                        @update-value="updatePage"
                      />
                      <div
                        class="
                          acs-gotopage-text
                          mr-2
                          ml-4
                          d-flex
                          justify-content-end
                        "
                      >
                        Showing :
                        <div
                          class="text-truncate ml-2 results-individual-width"
                          v-if="pageStart > total"
                        >
                          0
                        </div>
                        <div
                          v-else
                          class="text-truncate ml-2 results-individual-width"
                        >
                          {{ pageStart }}
                        </div>
                        <div class="text-truncate results-individual-width">
                          -
                        </div>
                        <div class="text-truncate results-individual-width">
                          {{ pageEnd }}
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          of
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          {{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- table ends -->
              </div>
            </b-tab>
            <b-tab
              title="Approved Jobs"
              @click="
                openPreview = false;
                getJobDesc(
                  (type = '2'),
                  (status = '3'),
                  (currentPage = 1),
                  (LoaderStatus = true),
                  (goToPage = null)
                );
              "
            >
              <template
                v-if="allJobs.length == 0 && !LoaderStatus && searchQuery == ''"
              >
                <div
                  class="
                    bu-head-no-data-class
                    d-flex
                    align-items-center
                    justify-content-center
                    flex-column
                  "
                >
                  <div>
                    <img src="../../assets/newJD/newJD-emptyData.svg" alt="" />
                  </div>
                  <div class="ml-4 teams-empty-container-font">
                    There are no approved jobs
                  </div>
                </div>
              </template>
              <div v-else>
                <!-- new table design starts from here -->
                <div class="newJD-main-table">
                  <div class="newJD-table-head">
                    <div class="text-left pl-3" style="width: 30%">
                      <span>Customer Name</span>
                      <template v-if="statusValue == 'customerName'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>

                    <div style="width: 30%" class="text-left">
                      <span>Job Name</span>
                      <template v-if="statusValue == 'title'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 25%" class="text-left">
                      <span>Approved on</span>
                    </div>

                    <div style="width: 15%" class="text-center">
                      <span>Action</span>
                    </div>
                  </div>
                  <div class="newJD-table-body" ref="tableContainer2">
                    <template
                      v-if="
                        allJobs.length == 0 &&
                        !LoaderStatus &&
                        searchQuery != ''
                      "
                    >
                      <div
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                          flex-column
                        "
                      >
                        <div>
                          <img
                            src="../../assets/newJD/newJD-emptyData.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-4 teams-empty-container-font">
                          No matching results for "{{ searchQuery }}"
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="newJD-table-row"
                        v-for="(job, index) in allJobs"
                        :key="job.jobID + index"
                      >
                        <div
                          class="text-left text-truncate pl-3"
                          style="width: 30%"
                        >
                          <span class="newJD-gridgreencolorDynamic"></span>

                          <span
                            style="min-width: auto; max-width: 95%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.customerName"
                            >{{ job.customerName }}</span
                          >
                        </div>

                        <div style="width: 30%" class="text-left">
                          <span
                            style="min-width: auto; max-width: 90%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.title"
                            >{{ job.title }}</span
                          >
                        </div>
                        <div style="width: 25%" class="text-left">
                          {{ job.ApprovedOn | formatdate }}
                        </div>

                        <div style="width: 15%" class="text-center">
                          <span>
                            <img
                              v-b-tooltip.hover.top="'Click to view'"
                              src="../../assets/img/accessconnew/blueEye.svg"
                              alt="/"
                              class="pointer"
                              @click="
                                (isPending = false), openPreviewSlide(job.jobID)
                              "
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="
                      acs-paginaTion-new
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div class="d-flex">
                      <span class="acs-gotopage-text p-1">Go to page</span>
                      <b-form-input
                        type="text"
                        class="acs-pagination-num mr-1"
                        v-model="goToPage"
                        @keyup.enter="
                          goToPage == null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages()
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>
                      <div class="acs-pagination-addbtn">
                        <span
                          :class="
                            goToPage === null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? 'disableDeleteIcon pl-3 mt-1'
                              : 'pointer pl-3 mt-1'
                          "
                        >
                          <img
                            @click="
                              goToPage == null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages()
                            "
                            src="../../assets/panelist/page_arrow.svg"
                            alt
                          />
                        </span>
                      </div>
                    </div>

                    <div class="pagination">
                      <b-pagination
                        v-model.number="currentPage"
                        @input="getJobDesc(), (goToPage = null)"
                        :total-rows="total"
                        :per-page="question_count"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/leftvector.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/rightarrow.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex align-items-center">
                      <PageInput
                        :pagecount="question_count"
                        @update-value="updatePage"
                      />
                      <div
                        class="
                          acs-gotopage-text
                          mr-2
                          ml-4
                          d-flex
                          justify-content-end
                        "
                      >
                        Showing :
                        <div
                          class="text-truncate ml-2 results-individual-width"
                          v-if="pageStart > total"
                        >
                          0
                        </div>
                        <div
                          v-else
                          class="text-truncate ml-2 results-individual-width"
                        >
                          {{ pageStart }}
                        </div>
                        <div class="text-truncate results-individual-width">
                          -
                        </div>
                        <div class="text-truncate results-individual-width">
                          {{ pageEnd }}
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          of
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          {{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab
              title="Rejected Jobs"
              @click="
                openPreview = false;
                getJobDesc(
                  (type = '1'),
                  (status = '4'),
                  (currentPage = 1),
                  (LoaderStatus = true),
                  (goToPage = null)
                );
              "
            >
              <template
                v-if="allJobs.length == 0 && !LoaderStatus && searchQuery == ''"
              >
                <div
                  class="
                    bu-head-no-data-class
                    d-flex
                    align-items-center
                    justify-content-center
                    flex-column
                  "
                >
                  <div>
                    <img src="../../assets/newJD/newJD-emptyData.svg" alt="" />
                  </div>
                  <div class="ml-4 teams-empty-container-font">
                    There are no rejected jobs
                  </div>
                </div>
              </template>
              <div v-else>
                <!-- new table design starts from here -->
                <div class="newJD-main-table">
                  <div class="newJD-table-head">
                    <div class="text-left pl-3" style="width: 30%">
                      <span>Customer Name</span>
                      <template v-if="statusValue == 'customerName'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'customerName'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>

                    <div style="width: 30%" class="text-left">
                      <span>Job Name</span>
                      <template v-if="statusValue == 'title'">
                        <img
                          v-if="sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/ascSort.svg"
                          alt=""
                        />
                        <img
                          v-if="!sortByValue && filter"
                          class="pointer ml-2"
                          @click="
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = !sortByValue)
                            )
                          "
                          src="../../assets/img/accessconnew/descSort.svg"
                          alt=""
                        />
                      </template>
                      <img
                        class="pointer ml-2"
                        v-else
                        @click="
                          (filter = true),
                            getJobDesc(
                              'sort',
                              (statusValue = 'title'),
                              (sortByValue = true)
                            )
                        "
                        src="../../assets/img/accessconnew/nosort.svg"
                        alt=""
                      />
                    </div>
                    <div style="width: 25%" class="text-left">
                      <span>Rejected on</span>
                    </div>

                    <div style="width: 15%" class="text-center">
                      <span>Action</span>
                    </div>
                  </div>
                  <div class="newJD-table-body" ref="tableContainer3">
                    <template
                      v-if="
                        allJobs.length == 0 &&
                        !LoaderStatus &&
                        searchQuery != ''
                      "
                    >
                      <div
                        class="
                          h-100
                          d-flex
                          align-items-center
                          justify-content-center
                          flex-column
                        "
                      >
                        <div>
                          <img
                            src="../../assets/newJD/newJD-emptyData.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-4 teams-empty-container-font">
                          No matching results for "{{ searchQuery }}"
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div
                        class="newJD-table-row"
                        v-for="(job, index) in allJobs"
                        :key="job.jobID + index"
                      >
                        <div class="text-left pl-3" style="width: 30%">
                          <span class="newJD-gridgreencolorDynamic"></span>
                          <span
                            style="min-width: auto; max-width: 95%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.customerName"
                            >{{ job.customerName }}</span
                          >
                        </div>

                        <div style="width: 30%" class="text-left text-truncate">
                          <span
                            style="min-width: auto; max-width: 90%"
                            class="text-truncate d-inline-block"
                            v-b-tooltip.hover.top="job.title"
                            >{{ job.title }}</span
                          >
                        </div>
                        <div style="width: 25%" class="text-left">
                          {{ job.rejectedOn | formatdate }}
                        </div>

                        <div style="width: 15%" class="text-center">
                          <span>
                            <img
                              v-b-tooltip.hover.top="'Click to view'"
                              src="../../assets/img/accessconnew/blueEye.svg"
                              alt="/"
                              class="pointer"
                              @click="
                                (isPending = false), openPreviewSlide(job.jobID)
                              "
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                  </div>
                  <div
                    class="
                      acs-paginaTion-new
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div class="d-flex">
                      <span class="acs-gotopage-text p-1">Go to page</span>
                      <b-form-input
                        type="text"
                        class="acs-pagination-num mr-1"
                        v-model="goToPage"
                        @keyup.enter="
                          goToPage == null ||
                          goToPage == '' ||
                          !iscontainsNumber
                            ? ''
                            : goToPages()
                        "
                        @keypress="NumbersOnly"
                        @paste="handlePaste"
                      ></b-form-input>
                      <div class="acs-pagination-addbtn">
                        <span
                          :class="
                            goToPage === null ||
                            goToPage == '' ||
                            !iscontainsNumber
                              ? 'disableDeleteIcon pl-3 mt-1'
                              : 'pointer pl-3 mt-1'
                          "
                        >
                          <img
                            @click="
                              goToPage == null ||
                              goToPage == '' ||
                              !iscontainsNumber
                                ? ''
                                : goToPages()
                            "
                            src="../../assets/panelist/page_arrow.svg"
                            alt
                          />
                        </span>
                      </div>
                    </div>

                    <div class="pagination">
                      <b-pagination
                        v-model.number="currentPage"
                        @input="goToPage = null"
                        :total-rows="total"
                        :per-page="question_count"
                        align="center"
                        first-number
                        last-number
                      >
                        <template #prev-text
                          ><span
                            ><img
                              src="../../assets/leftvector.svg"
                              alt=""
                            /> </span
                        ></template>
                        <template #next-text
                          ><span
                            ><img
                              src="../../assets/rightarrow.svg"
                              alt="" /></span
                        ></template>
                      </b-pagination>
                    </div>
                    <div class="d-flex align-items-center">
                      <PageInput
                        :pagecount="question_count"
                        @update-value="updatePage"
                      />
                      <div
                        class="
                          acs-gotopage-text
                          mr-2
                          ml-4
                          d-flex
                          justify-content-end
                        "
                      >
                        Showing :
                        <div
                          class="text-truncate ml-2 results-individual-width"
                          v-if="pageStart > total"
                        >
                          0
                        </div>
                        <div
                          v-else
                          class="text-truncate ml-2 results-individual-width"
                        >
                          {{ pageStart }}
                        </div>
                        <div class="text-truncate results-individual-width">
                          -
                        </div>
                        <div class="text-truncate results-individual-width">
                          {{ pageEnd }}
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          of
                        </div>
                        <div
                          class="text-truncate ml-1 results-individual-width"
                        >
                          {{ total }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <ReviewJds
        :openPreview="openPreview"
        :jobID="jobID"
        :isPending="isPending"
        :customFieldsArray="customFieldsArray"
        :basicArray="basicArray"
        :advanceArray="advanceArray"
        :costPerInterview="costPerInterview"
        @close-review-jds="openPreview = false"
      />
    </div>
  </div>
</template>

<script>
import {
  getReviewJD,
  getCustomerFields,
  getCreditsInfo,
} from "../../utils/apiFunctions.js";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import ReviewJds from "../../views/OpsheadJdApproval/ReviewJds.vue";
import EventBus from "../../utils/eventBus";
import { mapGetters } from "vuex";
import commonFunc from "../../components/mixin/commonFunctions.js";

export default {
  name: "ViewJds",
  mixins: [commonFunc],
  data() {
    return {
      total: null,
      pageStart: null,
      pageEnd: null,
      prevPage: null,
      goToPage: null,
      timer: null,
      costPerInterview: null,
      currentPage: 1,
      question_count: 50,
      status: "2",
      searchname: "",
      type: "1",
      statusValue: "updatedAt",
      sortByValue: false,
      LoaderStatus: false,
      filter: false,
      allJobs: [],
      advanceArray: [],
      basicArray: [],
      customFieldsArray: [],
      tabIndex: 0,
      openPreview: false,
      jobID: "",
      isPending: false,
    };
  },
  components: {
    Spinner,
    PageInput,
    ReviewJds,
  },
  created() {
    this.LoaderStatus = true;
    this.getSingleFormData();
    if (this.$route.query.status) {
      this.setTabIndex();
    } else this.getJobDesc();
    this.getCreditsInfo();
    EventBus.$on("on-close-acceptreject", this.triggerClose);
  },
  destroyed() {
    EventBus.$off("on-close-acceptreject", this.triggerClose);
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.question_count);
    },
    // To check if it does not contain an alphabet or zero
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
  },
  filters: {
    formatdate(value) {
      if (!value) return "";

      const date = new Date(value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        this.LoaderStatus = true;
        if (newValue != "Loader") {
          this.getJobDesc();
        }
      }
    },
    tabIndex(newValue) {
      let status;
      switch (newValue) {
        case 0:
          status = "pending";
          break;
        case 1:
          status = "accepted";
          break;
        case 2:
          status = "rejected";
          break;
        default:
          status = "pending";
          break;
      }
      // Update the route with the new status query parameter
      this.$router.push({
        name: "ViewJds",
        query: {
          status: status,
        },
      });
    },
  },
  methods: {
    async getCreditsInfo() {
      try {
        const res = await getCreditsInfo();
        if (res.status == 200) {
          this.costPerInterview = res.data.data.data.interviewCost;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getSingleFormData() {
      try {
        let parentID = "1";
        let response = await getCustomerFields({ parentID });
        if (response.status == 200) {
          this.customFieldsArray = response.data.data.fields;
          this.basicArray = [];
          this.advanceArray = [];
          this.customFieldsArray.forEach((obj) => {
            if (obj.category === 1 || obj.category === null) {
              this.basicArray.push(obj); // Push objects with category value 1 into category1Array
            } else if (obj.category === 2) {
              this.advanceArray.push(obj); // Push objects with category value 2 into category2Array
            }
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    updatePage(value) {
      this.question_count = value;
      this.currentPage = 1;
      this.LoaderStatus = true;
      this.getJobDesc();
    },
    triggerClose() {
      this.openPreview = false;
      this.setTabIndex();
    },
    openPreviewSlide(jobID) {
      this.openPreview = true;
      this.jobID = jobID;
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    // Get data Api
    async getJobDesc() {
      this.LoaderStatus = true;
      let payload = {
        type: this.type,
        page: this.currentPage - 1,
        count: this.question_count,
        sortBy: {
          column: this.statusValue,
          order: this.sortByValue,
        },
        filters: {
          active: "true",
        },
        searchQuery: this.searchQuery,
        status: this.status,
      };

      if (this.roles && this.roles.includes("VIEW_ADMIN")) {
        payload.admin = true;
      }

      try {
        const response = await getReviewJD(payload);
        if (response.status == 200) {
          this.allJobs = response.data.data.data;
          this.total = response.data.data.total;
          this.pageStart = response.data.data.pageStart;
          this.pageEnd = response.data.data.pageEnd;
          this.prevPage = response.data.data.prevPage;

          this.LoaderStatus = false;

          // Determine the tableRef based on some condition (e.g., route query status)
          let tableRef;
          switch (this.$route.query.status) {
            case "rejected":
              tableRef = "tableContainer3";
              break;
            case "accepted":
              tableRef = "tableContainer2";
              break;
            case "pending":
              tableRef = "tableContainer1";
              break;
            default:
              tableRef = "tableContainer1";
              break;
          }

          // Scroll to the top of the specified table container with smooth behavior
          this.$nextTick(() => {
            const tableContainer = this.$refs[tableRef];
            if (tableContainer) {
              tableContainer.scrollTo({ top: 0, behavior: "smooth" });
            }
          });
        }
      } catch (error) {
        this.LoaderStatus = false;
        throw new Error(`Failed! getting jds ! status: ${error.status}`);
      }
    },
    // Go to selected Page
    goToPages() {
      this.currentPage = Math.min(Math.max(1, this.goToPage), this.totalPages);
      this.goToPage = null;
      this.getJobDesc();
    },
    // Set tabIndex based on the query variables (check watcher)
    setTabIndex() {
      switch (this.$route.query.status) {
        case "accepted":
          this.tabIndex = 1;
          this.status = "3";
          this.type = "2";
          break;
        case "rejected":
          this.tabIndex = 2;
          this.status = "4";
          this.type = "1";
          break;
        default:
          this.tabIndex = 0;
          this.status = "2";
          this.type = "1";
      }
      this.getJobDesc();
      this.currentPage = 1;
      this.goToPage = null;
      this.LoaderStatus = true;
    },
  },
};
</script>

<style scoped>
.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}

.bu-head-no-data-class {
  height: calc(100vh - 150px);
}
</style>
